import React, { useRef } from 'react';
import useMergedRef from '@react-hook/merged-ref';
import { Check } from '@beamery/lib-ds-icons';
import { useOption } from '@react-aria/listbox';
import { omit } from '../../utils/index.js';
import { Checkbox } from '../checkbox/index.js';
import { ListBoxItemElement, ListBoxItemLabelElement, ListBoxItemSelectedIconElement, } from './list-box.styles.js';
export const ListBoxItem = React.forwardRef(({ state, listItem, dataAutomation = 'list-item', shouldUseVirtualFocus, showSelectionCheck = true, }, forwardedRef) => {
    const itemRef = useRef(null);
    const ref = useMergedRef(forwardedRef, itemRef);
    const { optionProps, isSelected, isFocused, labelProps } = useOption({
        key: listItem.key,
        shouldUseVirtualFocus,
    }, state, itemRef);
    return (React.createElement(ListBoxItemElement, { ...optionProps, "data-automation": dataAutomation, title: listItem.textValue, isFocused: isFocused, ref: ref }, listItem.value?.variant === 'checkbox-item' ? (React.createElement(Checkbox, { dataAutomation: `${dataAutomation}/checkbox`, label: listItem.rendered, isSelected: isSelected, excludeFromTabOrder: true, disableHoverStyling: true, disableInteractions: true })) : (React.createElement(React.Fragment, null,
        React.createElement(ListBoxItemLabelElement, { ...omit(labelProps, 'color'), isSelected: isSelected }, listItem.rendered),
        isSelected && showSelectionCheck ? (React.createElement(ListBoxItemSelectedIconElement, null,
            React.createElement(Check, { color: 'inherit' }))) : null))));
});
//# sourceMappingURL=list-box-item.component.js.map